import {atom, useAtomValue, useSetAtom} from 'jotai';
import {useAtomCallback} from 'jotai/react/utils';
import {useCallback, useEffect} from 'react';

import {FAILED_AUTH_INDEX} from '@web-catalog/const/numbers';

import {ProfileType} from '@web-catalog/types';

// flows:
// idle -> in_progress -> failed
// idle -> in_progress -> notify_user -> finished
type AuthProgressState =
  | 'idle'
  | 'in_progress'
  | 'failed'
  | 'notify_user'
  | 'finished';

const authProgressStateAtom = atom<AuthProgressState>('idle');
export const useSetAuthProgressState = () => useSetAtom(authProgressStateAtom);
export const useAuthProgressState = () => useAtomValue(authProgressStateAtom);

export const authDoneStates = ['failed', 'finished'];

const authorizedProfileAtom = atom<ProfileType | undefined>(undefined);
export const useSetAuthorizedProfile = () => useSetAtom(authorizedProfileAtom);
export const useAuthorizedProfile = () => useAtomValue(authorizedProfileAtom);

export const useGetAuthorizedProfile = () =>
  useAtomCallback(useCallback((get) => get(authorizedProfileAtom), []));

export const useGetVkId = () => {
  const getProfile = useGetAuthorizedProfile();
  return useCallback(() => getProfile()?.id ?? FAILED_AUTH_INDEX, [getProfile]);
};

export const useRunAfterAuthorizationDoneWithVkId = (
  callback: (vkId: number) => void,
) => {
  const authProgressState = useAuthProgressState();
  const isAuthDone = authDoneStates.includes(authProgressState);
  const getVkId = useGetVkId();
  useEffect(() => {
    if (!isAuthDone) {
      return;
    }
    callback(getVkId());
  }, [isAuthDone, getVkId, callback]);
};
